module.exports = __webpack_public_path__ + "static/media/starReview.60a0c0f0.svg";